<template>
	<div class="field mb-2" :style="field.style" v-if="condition">
		<div class="is-flex attribute-field items-center" :class="{ 'attributes-collapsible-header': field.collapsible }" @click="field.collapsible ? (attributesCollapsed = !attributesCollapsed) : null">
			<label v-if="Object.keys(local_value.options).length > 0 || local_value.is_exclusive" class="label mb-0 mr-auto" :style="field.collapsible ? 'cursor: pointer;' : ''">
				{{ local_value.label }}
				{{ local_value.required ? ' *' : '' }}
				<i v-if="field.collapsible" class="fa ml-2" :class="attributesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
			</label>
			<div v-if="show_exclusive_attributes_list" class="flex-1 ml-2" @click.stop>
				<div class="select is-small w-full">
					<select v-model="selectedToBeAddedAttribute">
            <option :value="null">Zgjidh atribut</option>
						<option v-for="attr in local_value.exclusive_options" 
              :key="attr" 
							:value="attr.id">{{attr.label}}</option>
					</select>
				</div>
			</div>
			<a v-if="local_value.is_exclusive" @click.prevent="start_add_exclusive_attributes()" href="" class="button is-small ml-2">
				<i v-if="show_exclusive_attributes_list && selectedToBeAddedAttribute" class="fa-solid fa-plus"></i>
				<i v-else class="fa-solid fa-eye"></i>
			</a>
			<a
				v-if="showCopyFromProduct"
				href=""
				class="button is-small is-info is-light ml-2"
				:class="{ 'is-loading': copying }"
				:disabled="!canCopyFromProduct || copying"
				@click.stop.prevent="toggleCopySearch"
				title="Kopjo atribute nga një produkt tjetër në të njëjtën kategori"
			>
				<i class="fa fa-copy mr-1"></i>Kopjo nga produkt
			</a>
		</div>
		<div v-if="showCopyFromProduct && showCopySearch" class="attribute-copy-panel mb-3" @click.stop>
			<p class="help mb-2">
				Kërko produktin burim (i njëjti katalog). Duhet të jetë në të njëjtën kategori.
			</p>
			<div class="is-flex mb-2" style="gap: 0.5rem">
				<input
					class="input is-small"
					type="text"
					v-model="searchQuery"
					placeholder="Kodi, emri, modeli..."
					@input="onSearchInput"
					@keyup.enter="runSearch"
				/>
				<span v-if="searching" class="is-size-7 has-text-grey" style="align-self: center">
					<i class="fa fa-spinner fa-spin"></i>
				</span>
			</div>
			<div v-if="searchResults.length > 0" class="box is-paddingless mb-2" style="max-height: 200px; overflow-y: auto">
				<a
					v-for="result in searchResults"
					:key="result.guid"
					href=""
					class="dropdown-item is-size-7 py-2 px-3"
					style="display: block; border-bottom: 1px solid #eee"
					@click.prevent="copyFromProduct(result)"
				>
					{{ result.label }}
				</a>
			</div>
			<p v-if="!canCopyFromProduct" class="help mb-2">Zgjidh kategorinë së pari</p>
			<p v-if="copyError" class="help is-danger mb-2">{{ copyError }}</p>
			<p v-else-if="searchQuery.length >= 2 && !searching && searchResults.length === 0 && searchTouched" class="help mb-2">
				Nuk u gjet asnjë produkt.
			</p>
		</div>
		<div class="attributes-list" v-show="!field.collapsible || !attributesCollapsed">
			<div v-for="o in Object.keys(local_value.options)" 
				class="attribute-row has-border"
				:key="o">
				<div class="attribute-row-inner">
					<label :for="local_value.options[o].root.guid" class="attribute-label">
						<span class="attribute-name">{{ local_value.options[o].root.name }}</span>
						<span v-if="local_value.options[o].root.is_required" class="required-asterisk" aria-hidden="true">*</span>
					</label>
					<div class="attribute-input-wrap">
						<input 
							:id="local_value.options[o].root.guid"
							:name="local_value.options[o].root.guid"
							:class="['input is-small', { 'is-danger': local_value.options[o].root.is_required && isValueEmpty(local_value.options[o].root) }]"
							v-model="local_value.options[o].root.value" 
							:type="local_value.options[o].root.type"
							v-if="['text', 'number'].includes(local_value.options[o].root.type)"
						>
						<textarea
							v-else-if="local_value.options[o].root.type === 'textarea'"
							:id="local_value.options[o].root.guid"
							:name="local_value.options[o].root.guid"
							:class="['textarea is-small', { 'is-danger': local_value.options[o].root.is_required && isValueEmpty(local_value.options[o].root) }]"
							v-model="local_value.options[o].root.value"
							rows="2"
						></textarea>
            <div
              v-else-if="['checkbox'].includes(local_value.options[o].root.type)"
              class="attribute-radio-group"
            >
              <label class="radio is-size-7 mr-3">
                <input
                  type="radio"
                  :name="local_value.options[o].root.guid"
                  value="1"
                  v-model="local_value.options[o].root.value"
                />
                <span>Po</span>
              </label>
              <label class="radio is-size-7">
                <input
                  type="radio"
                  :name="local_value.options[o].root.guid"
                  value="0"
                  v-model="local_value.options[o].root.value"
                />
                <span>Jo</span>
              </label>
            </div>
						<AttributeOptionPicker
							v-else-if="['select', 'multiselect'].includes(local_value.options[o].root.type)"
							v-model="local_value.options[o].root.value"
							:options="local_value.options[o].children"
							:category-id="getCategoryId(local_value.options[o].root)"
							:attribute-id="local_value.options[o].root.guid"
							:type="local_value.options[o].root.type"
							:input-id="local_value.options[o].root.guid"
							:has-error="local_value.options[o].root.is_required && isValueEmpty(local_value.options[o].root)"
							@options-changed="onOptionsChanged(o, $event)"
						/>
					</div>
					<AttributeUnitPicker
						:measuring-unit="local_value.options[o].root.measuring_unit"
						:default-measuring-unit="local_value.options[o].root.default_measuring_unit"
						:measuring-unit-name="local_value.options[o].root.measuring_unit_name"
						:units="unitOptions"
						:category-id="getCategoryId(local_value.options[o].root)"
						:attribute-id="local_value.options[o].root.guid"
						:category-related-entity="unitCategoryRelatedEntity"
						@update:measuringUnit="onMeasuringUnitChanged(o, $event)"
						@units-changed="onUnitsChanged"
					/>
				</div>
				<p class="help is-danger attribute-error" v-if="local_value.options[o].root.is_required && isValueEmpty(local_value.options[o].root)">
					E detyrueshme
				</p>
			</div>
		</div>
		<p class="help is-danger" v-if="local_value.unique !== undefined">
			<span v-if="local_value.exists == 1">
				{{local_value.label}} vendosur eshte i zene!
			</span>
		</p>
		<p class="help is-danger" v-if="false && local_value.required && (!local_value.value || local_value == '')">
			{{ local_value.required_text ? local_value.required_text : 'E detyrueshme' }}
		</p> 
	</div>
</template>

<script>
	import helpers from "@/helpers.js";
	import UnitsServices from "@/services/Unit";
	import CategoriesServices from "@/services/Category";
	import ProductsServices, { isValidProductGuid } from "@/services/Product";
	import AttributeOptionPicker from "./AttributeOptionPicker.vue";
	import AttributeUnitPicker from "./AttributeUnitPicker.vue";

	export default{
		components: {
			AttributeOptionPicker,
			AttributeUnitPicker,
		},
		props: [
			'field', 'fields'
		], 
		data() {
			return {
				local_value: null,
				show_exclusive_attributes_list: false,
				selectedToBeAddedAttribute: null,
				attributesCollapsed: false,
				unitOptions: [],
				showCopySearch: false,
				searchQuery: "",
				searchResults: [],
				searching: false,
				searchTouched: false,
				searchTimer: null,
				copyError: null,
				copying: false,
			};
		},
		methods: {
			cloneField() {
				// Deep clone so local_value never shares nested objects (options/root/children)
				// with the parent's field prop. Shared references are what let edits in one
				// place cross-trigger watchers elsewhere and spiral into an update loop.
				let cloned;
				try {
					cloned = JSON.parse(JSON.stringify(this.field));
				} catch (e) {
					cloned = { ...this.field };
				}
				if (cloned && !isValidProductGuid(cloned.exclude_product_guid)) {
					delete cloned.exclude_product_guid;
				}
				return cloned;
			},
			isValueEmpty(root) {
				const v = root.value;
				if (v === null || v === undefined) return true;
				if (root.type === 'multiselect') {
					if (Array.isArray(v)) return v.length === 0;
					if (typeof v === 'string' && v !== '') {
						try {
							const parsed = JSON.parse(v);
							return !Array.isArray(parsed) || parsed.length === 0;
						} catch {
							return true;
						}
					}
					return true;
				}
				if (['text', 'number', 'textarea'].includes(root.type)) return String(v).trim() === '';
				if (root.type === 'checkbox') return !['0', '1'].includes(String(v));
				return String(v).trim() === '';
			},
			getCategoryId(root) {
				if (root.category_id) return root.category_id;
				const dep = root.dependency;
				if (typeof dep === 'string') return dep;
				if (dep && typeof dep === 'object') return Object.keys(dep)[0];
				return '';
			},
			onOptionsChanged(optionKey, options) {
				if (!this.local_value?.options?.[optionKey]) return;
				this.local_value.options[optionKey].children = options;
				this.$emit('syncField', this.local_value);
			},
			onMeasuringUnitChanged(optionKey, unitId) {
				if (!this.local_value?.options?.[optionKey]) return;
				this.local_value.options[optionKey].root.measuring_unit = unitId;
				this.$emit('syncField', this.local_value);
			},
			onUnitsChanged(units) {
				this.unitOptions = units;
			},
			start_add_exclusive_attributes(){
				if(this.selectedToBeAddedAttribute != null) {
					this.local_value = {
						...this.local_value, 
						options: {
							...this.local_value.options,
							...helpers.create_attributes_field(
								this.local_value.exclusive_options[this.selectedToBeAddedAttribute].attributes, 
								'EXCLUSIVE')
						},
					}
					this.local_value = JSON.parse(JSON.stringify(this.local_value))
					this.$emit('syncField', this.local_value)
          this.show_exclusive_attributes_list = false
				}else {
					this.show_exclusive_attributes_list = !this.show_exclusive_attributes_list
				}
			},
			findField(name) {
				if (!this.fields) return null;
				for (const f of this.fields) {
					const rows = Array.isArray(f) ? f : [f];
					for (const ff of rows) {
						if (ff.name === name) return ff;
					}
				}
				return null;
			},
			snapshotCardField(name) {
				const field = this.findField(name);
				if (!field) return null;
				return {
					value: field.value,
					selected_options: field.selected_options
						? JSON.parse(JSON.stringify(field.selected_options))
						: {},
				};
			},
			restoreCardField(name, snapshot) {
				if (!snapshot) return;
				const field = this.findField(name);
				if (!field) return;
				const sameValue = String(field.value ?? "") === String(snapshot.value ?? "");
				const currentOpts = JSON.stringify(field.selected_options || {});
				const snapOpts = JSON.stringify(snapshot.selected_options || {});
				if (sameValue && currentOpts === snapOpts) return;
				this.$emit("syncField", {
					...field,
					value: snapshot.value,
					selected_options: snapshot.selected_options || {},
				});
			},
			getCurrentCategorySelection() {
				const fieldName = this.local_value?.name === "attributes_accessories" ? "accessory_id" : "type_id";
				const catField = this.findField(fieldName);
				if (!catField?.selected_options || typeof catField.selected_options !== "object") return null;
				const keys = Object.keys(catField.selected_options);
				if (!keys.length) return null;
				const guid = keys[0];
				return {
					guid,
					name: catField.selected_options[guid],
					selectedCategory: { [guid]: catField.selected_options[guid] },
				};
			},
			toggleCopySearch() {
				if (!this.canCopyFromProduct || this.copying) return;
				this.showCopySearch = !this.showCopySearch;
				if (!this.showCopySearch) {
					this.searchQuery = "";
					this.searchResults = [];
					this.searchTouched = false;
					this.copyError = null;
				}
			},
			onSearchInput() {
				if (this.searchTimer) clearTimeout(this.searchTimer);
				this.searchTimer = setTimeout(() => this.runSearch(), 300);
			},
			async runSearch() {
				const q = (this.searchQuery || "").trim();
				if (q.length < 2) {
					this.searchResults = [];
					this.searchTouched = false;
					return;
				}
				this.searching = true;
				this.searchTouched = true;
				this.copyError = null;
				try {
					const results = await ProductsServices.searchComponents(q, this.excludeGuid);
					const list = Array.isArray(results) ? results : results?.data || [];
					this.searchResults = list;
				} catch (e) {
					this.searchResults = [];
					const err = e?.response?.data;
					const firstFieldError =
						err?.errors?.q?.[0] || err?.errors?.exclude_guid?.[0] || Object.values(err?.errors || {})[0]?.[0];
					this.copyError = firstFieldError || err?.message || "Gabim gjatë kërkimit.";
				} finally {
					this.searching = false;
				}
			},
			async copyFromProduct(result) {
				if (!result?.guid || this.copying) return;
				this.copying = true;
				this.copyError = null;
				const brandSnapshot = this.snapshotCardField("brand");
				const supplierSnapshot = this.snapshotCardField("supplier");
				try {
					const currentCat = this.getCurrentCategorySelection();
					if (!currentCat) {
						this.copyError = "Zgjidh kategorinë së pari";
						return;
					}

					const sourceProduct = await ProductsServices.get({ guid: result.guid });
					// Only category keys — never apply card fields (brand, supplier, etc.)
					const sourceGuid = sourceProduct?.guid;
					const sourceIsAccessory = Number(sourceProduct?.is_accessory) === 1;
					const sourceTypeId = sourceProduct?.type_id;
					const sourceAccessoryId = sourceProduct?.accessory_id;

					const isAccessoryField = this.local_value.name === "attributes_accessories";
					const sourceCatId = isAccessoryField ? sourceAccessoryId : sourceTypeId;

					if (isAccessoryField !== sourceIsAccessory || String(sourceCatId) !== String(currentCat.guid)) {
						this.copyError = "Produkti duhet të jetë në të njëjtën kategori";
						return;
					}

					const rawAttrs = await CategoriesServices.getCategoryAttributes(
						currentCat.selectedCategory,
						{ guid: sourceGuid }
					);
					const sourceOptions = helpers.create_attributes_field(rawAttrs, currentCat.guid);
					const { merged, copiedCount, skippedSelectCount } = helpers.mergeAttributeOptionsFromSource(
						this.local_value.options,
						sourceOptions
					);

					if (copiedCount === 0) {
						if (this.$toast?.error) {
							this.$toast.error("Produkti burim nuk ka atribute të plotësuara");
						} else {
							this.copyError = "Produkti burim nuk ka atribute të plotësuara";
						}
						return;
					}

					this.local_value = {
						...this.local_value,
						options: merged,
					};
					this.local_value = JSON.parse(JSON.stringify(this.local_value));
					this.$emit("syncField", this.local_value);

					// Hard guarantee: Marka / Furnitori stay as they were before copy
					this.restoreCardField("brand", brandSnapshot);
					this.restoreCardField("supplier", supplierSnapshot);

					let msg = `U kopjuan ${copiedCount} atribute`;
					if (skippedSelectCount > 0) {
						msg += ` (${skippedSelectCount} u anashkaluan për shkak të opsioneve)`;
					}
					if (this.$toast?.success) {
						this.$toast.success(msg);
					}

					this.showCopySearch = false;
					this.searchQuery = "";
					this.searchResults = [];
					this.searchTouched = false;
				} catch (e) {
					this.copyError = e?.message || "Gabim gjatë kopjimit të atributeve";
				} finally {
					this.copying = false;
				}
			},
		},
		
		computed: {
			showCopyFromProduct() {
				const name = this.local_value?.name;
				return (name === "attributes" || name === "attributes_accessories") && !this.local_value?.is_exclusive;
			},
			unitCategoryRelatedEntity() {
				const name = this.local_value?.name;
				if (name === "attributes_accessories") return "accessories";
				if (name === "services") return "services";
				return "products";
			},
			canCopyFromProduct() {
				return !!this.getCurrentCategorySelection() && Object.keys(this.local_value?.options || {}).length > 0;
			},
			excludeGuid() {
				const fromField = this.local_value?.exclude_product_guid;
				if (isValidProductGuid(fromField)) return fromField.trim();
				return null;
			},
			condition(){
				var is_visible = true
				if(this.local_value.vif){
				if(this.fields)
					this.fields.map(f => {
						if(f.length) {
							f.map(ff => {
								this.local_value.vif.map(c => {
									if(ff.name == c.field){
										if(c.value_not !== undefined) 
											is_visible = ff.value != c.value_not
									}
								})
							})
						}
						else {
								this.local_value.vif.map(c => {
									if(f.name == c.field) {
										if(c.value_not !== undefined) {
											is_visible = f.value != c.value_not
										}
										if(c.value !== undefined) {
											is_visible = f.value == c.value
										}

									}
								})
						}
					})
				}
				return is_visible
			},
		},
		watch: {
			'field'(){
				// Adopt incoming prop data (echoed-back data from DaForm.syncField, or a
				// genuine external update such as new options after a category change).
				this.local_value = this.cloneField();
			},
      local_value: {
        deep: true,
        handler() {
          // Emit ONLY when our local copy actually diverges from the parent field.
          // DaForm echoes local_value back into the field prop on every syncField, so
          // once the two match again we stop. This makes the
          // field <-> local_value <-> syncField feedback loop (tab freeze) impossible,
          // regardless of whether the attribute set is empty, has no values, etc.
          let a, b;
          try {
            a = JSON.stringify(this.local_value);
            b = JSON.stringify(this.field);
          } catch (e) {
            a = 1; b = 0;
          }
          if (a === b) return;
          this.$emit('syncField', this.local_value);
        },
      },
		},
		async created(){
			this.local_value = this.cloneField();
			try {
				this.unitOptions = await UnitsServices.getUnits();
			} catch {
				this.unitOptions = [];
			}
		},
		beforeUnmount() {
			if (this.searchTimer) clearTimeout(this.searchTimer);
		},
	}
</script>

<style scoped>
.label {
  margin-bottom: 0 !important;
  color: grey;
}

.attributes-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.attribute-row {
  padding: 0.5rem 0;
  border-bottom: 1px solid #e8e8e8;
}

.attribute-row:last-child {
  border-bottom: none;
}

.attribute-row-inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 2rem;
}

.attribute-label {
  flex: 0 0 auto;
  min-width: 140px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #363636;
  font-size: 0.9rem;
  padding-top: 0.35rem;
}

.attribute-name {
  flex-shrink: 0;
}

.required-asterisk {
  color: #b94a48;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1;
}

.attribute-input-wrap {
  flex: 1;
  min-width: 0;
}

.attribute-input-wrap .input,
.attribute-input-wrap .select,
.attribute-input-wrap .textarea {
  width: 100%;
}

.attribute-input-wrap .select select {
  width: 100%;
}

.attribute-checkbox {
  width: auto;
  margin: 0;
}

.attribute-error {
  margin: 0.2rem 0 0 0;
  padding-left: 0;
  font-size: 0.8rem;
}

.attribute-input-wrap .input.is-danger,
.attribute-input-wrap .select.is-danger select,
.attribute-input-wrap .textarea.is-danger {
  border-color: #b94a48;
}

.attribute-copy-panel {
  padding: 0.75rem;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
}
</style>
